import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TeamMember = {
  id: string;
  name: string;
  email: string;
  phone?: string;
};

type OnboardingState = {
  name: string;
  email: string;
  phoneNumber: string;
  title: string;
  profilePicture: string;
  role: { id: string; name: string; type: string };
  hasCompany: boolean;
  company: {
    name: string;
    phone: string;
    email: string;
    website: string;
    type: string;
    size: string;
    address: string;
    stateLicenseNumbers: string[];
    profilePicture: string;
  };
  teamEmails: string;
  teamMembers: TeamMember[];
};

const initialState: OnboardingState = {
  name: "",
  email: "",
  phoneNumber: "",
  title: "",
  profilePicture: "",
  role: { id: "", name: "", type: "" },
  hasCompany: false,
  company: {
    name: "",
    phone: "",
    email: "",
    website: "",
    type: "",
    size: "",
    address: "",
    stateLicenseNumbers: [],
    profilePicture: "",
  },
  teamEmails: "",
  teamMembers: [],
};

type CompanyKeys = keyof OnboardingState["company"];

const onboardingUiSlice = createSlice({
  name: "onboardingUi",
  initialState,
  reducers: {
    setName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setPhoneNumber: (state, action: PayloadAction<string>) => {
      state.phoneNumber = action.payload;
    },
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
    setProfilePicture: (state, action: PayloadAction<string>) => {
      state.profilePicture = action.payload;
    },
    setRole: (
      state,
      action: PayloadAction<{ id: string; name: string; type: string }>
    ) => {
      const { id, name, type } = action.payload;
      state.role = { id, name, type };
    },
    setHasCompany: (state, action: PayloadAction<boolean>) => {
      state.hasCompany = action.payload;
    },
    setWorkspace: (
      state,
      action: PayloadAction<{ key: CompanyKeys; value: any }>
    ) => {
      const { key, value } = action.payload;
      state.company[key] = value;
    },
    setTeamEmails: (state, action: PayloadAction<string>) => {
      state.teamEmails = action.payload;
    },
    addTeamMember: (state, action: PayloadAction<TeamMember>) => {
      state.teamMembers.push(action.payload);
    },
    removeTeamMember: (state, action: PayloadAction<string>) => {
      state.teamMembers = state.teamMembers.filter(
        (member) => member.id !== action.payload
      );
    },
    clearTeamMembers: (state) => {
      state.teamMembers = [];
    },
  },
});

export const {
  setName,
  setEmail,
  setPhoneNumber,
  setTitle,
  setProfilePicture,
  setRole,
  setWorkspace,
  setHasCompany,
  setTeamEmails,
  addTeamMember,
  removeTeamMember,
  clearTeamMembers,
} = onboardingUiSlice.actions;
export default onboardingUiSlice.reducer;
